import Wrapper from "../../../components/layout/Wrapper";
import logo from "../../../assets/Images/logo.svg";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBoltLightning, faCoins, faFire, faPerson, faSignOut, faTrophy} from "@fortawesome/free-solid-svg-icons";
import ButtonLink from "../../../components/elements/ButtonLink";
import React from "react";
import PageTitle from "../../../components/layout/PageTitle";
import {toFarsiNumber} from "../../../utils/commonUtils";
import useEnergy from "../../../hooks/useEnergy";

const HeaderStructure = ({userId = null, title = "", xp = 0, credit = 0, streak = 0, hasPurchased = false, courseId = null}) => {
    const {energy, maxEnergy, loading} = useEnergy(userId);

    return (<header className='mt-4'>
            <Wrapper>
                <div className='w-full flex flex-1 items-center'>
                    <div className='flex flex-col items-center lg:flex-row mb-10'>
                        <div className='flex gap-x-3 items-center'>
                            <img src={logo} alt='Codepro' className='h-16'/>
                            <span className='text-2xl font-bold'>کدپرو</span>
                        </div>
                        <div className='hidden lg:flex justify-between mx-10 items-center'>
                            <h1 className={`text-3xl`}>{title}</h1>
                        </div>
                    </div>
                    <div className='mr-auto flex gap-x-5'>
                        {
                            !hasPurchased ?? <ButtonLink
                                to={`/fa/account/course/purchase/${courseId}`}>
                                <span>خرید دوره</span>
                                <FontAwesomeIcon icon={faCoins} size='md'/>
                            </ButtonLink>
                        }
                        <div
                            className='w-72 border-2 hidden lg:flex relative border-gray-200 text-lg font-bold rounded-md bg-gray-100 items-center'>
                            <div
                                className='w-1/4 border-l-2 flex justify-center items-center gap-x-3 border-gray-200 p-5'>
                                <span>{credit}</span>
                                <FontAwesomeIcon icon={faCoins} size='md'/>
                            </div>
                            <div
                                className='w-1/4 border-l-2 flex justify-center items-center gap-x-3 border-gray-200 p-5'>
                                <span>{streak}</span>
                                <FontAwesomeIcon icon={faFire} size='md'/>
                            </div>
                            <div className='w-1/4 border-l-2 flex justify-center items-center gap-x-3 border-gray-200 p-5'>
                                <span>{xp}</span>
                                <FontAwesomeIcon icon={faPerson} size='md'/>
                            </div>
                            <div className='w-1/4 flex justify-center items-center gap-x-3'>
                                <span>{loading && energy === null ? '…' : `${toFarsiNumber(energy)}`}</span>
                                <FontAwesomeIcon icon={faBoltLightning}/>
                            </div>
                        </div>
                        <ButtonLink to={`/fa/account/course/`}>
                            <FontAwesomeIcon icon={faSignOut} className='rotate-180'/>
                        </ButtonLink>
                    </div>
                </div>
            </Wrapper>
        </header>);
}

export default HeaderStructure;